import React from "react";
import { Rifm } from 'rifm';
import { Alert } from 'react-bootstrap'
import { quoteStepChanged } from "../../state/appActions";
import { saveCreditCardPaymentInfo, getViolations, bindQuote, IBindQuoteResponse } from "../../state/fullQuoteActions";
import { IQuoteStepState } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { connect } from "react-redux";
import { PATHS, FULL_QUOTE_STEPS, COMPONENTS } from "../../AppConstants";
import { ValidatableForm } from "../../components/ValidatableForm"
import { ValidatableFormGroup } from "../../components/ValidatableFormGroup"
import { IQuoteStepComponentProps } from "../../components/interfaces";
import { validationUtils } from "../../validation/Validation";
import { QuoteStep } from "./QuoteStepLayout";
import ButtonContinue from "../../components/ButtonContinue";
import QuoteStepBase from '../../components/QuoteStepBase'
import { IAddress, IAddressChangeResult, emptyAddress, IPaymentChoice, ICreditCardInfo, IPerson } from "../../classes/Domain";
import Address from "../../components/Address";
import ComplexCheckbox from "../../components/ComplexCheckbox";
import Utilities from "../../classes/Utilities";
import { IUpdateCreditCardResult, IBindQuoteResult } from "../../classes/ExternalQuote";
import AuthorizeVerify from "../../components/AuthorizeVerify";
import _ from "lodash";

interface IAppStateUpdate {
    quoteId: number,
    paymentInfo: ICreditCardInfo;
}

interface IState extends IQuoteStepState {
    cardHolderFirstName: string,
    cardHolderLastName: string,
    cardNumber: string,
    cardExpirationFull: string,
    cardExpirationMonth: number | null,
    cardExpirationYear: number | null,
    billingAddress: IAddress | null,
    updateResult: IUpdateCreditCardResult | null,
    bindQuoteResult: IBindQuoteResult | null,
    savePaymentMethod: boolean,
    invalidBillingAddress: boolean,
    useHomeAddressForBilling: boolean;
}

interface IProps extends IQuoteStepComponentProps {
    quoteId: number,
    insured: IPerson,
    paymentChoice: IPaymentChoice | null,
    hasAdditionalDrivers: boolean,
    updateAppStateViolations: (quoteId: number) => Promise<any>,
    bindQuote: (quoteId: number) => Promise<IBindQuoteResponse>;
}

class Payment extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);
        this.stopUpdate = this.stopUpdate.bind(this);
        this.onBillingAddressChanged = this.onBillingAddressChanged.bind(this);

        this.state = {
            cardHolderFirstName: "",
            cardHolderLastName: "",
            //cardNumber: "4111111111111111",
            cardNumber: "",
            cardExpirationFull: "",
            cardExpirationMonth: null,
            cardExpirationYear: null,
            billingAddress: emptyAddress,
            updatingStore: false,
            savePaymentMethod: true,
            useHomeAddressForBilling: false,
            invalidBillingAddress: true,
            updateResult: null,
            bindQuoteResult: null,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        this.setState({ ...this.state, updatingStore: false, errors: null });

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.PAYMENT,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(FULL_QUOTE_STEPS.PAYMENT);
    }

    //static getDerivedStateFromProps(nextProps: IProps, prevState: IState) {
    //    if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
    //        let insured = nextProps.insured;
    //        if (insured && insured.address) {
    //            const { address } = { ...insured };

    //            return {
    //                ...prevState,
    //                billingAddress: address
    //            };
    //        }
    //    }

    //    return prevState;
    //}

    onBillingAddressChanged(result: IAddressChangeResult) {
        this.setState({
            ...this.state, billingAddress: result.address, invalidBillingAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        });
    }

    setCardExpirationValues(cardExpirationRaw: string) {
        this.setState({ cardExpirationFull: cardExpirationRaw }, () => {
            let expMonth = 0;
            let expYear = 0;
            const [month = "", year = ""] = cardExpirationRaw.split('/');

            if (month) {
                expMonth = parseInt(month.replace(/^\0+/, ""), 10)
            }

            if (year) {
                expYear = parseInt(year, 10)
            }

            this.setState({ ...this.state, cardExpirationMonth: expMonth, cardExpirationYear: expYear });
        });
    }

    stopUpdate() {
        this.setState({ ...this.state, updatingStore: false });
    }

    changeUseHomeAddressAsBilling() {
        let useHomeAddress = !this.state.useHomeAddressForBilling;

        if (useHomeAddress) {
            let insured = this.props.insured;
            if (insured && insured.address) {
                const { address } = { ...insured };
                this.setState({ useHomeAddressForBilling: useHomeAddress, billingAddress: address },
                    () => {
                        if (address) {
                            this.onBillingAddressChanged({ address, isFull: true, isValid: true });
                        }
                    });
            }
        }
        else {
            this.setState({ ...this.state, useHomeAddressForBilling: useHomeAddress, billingAddress: emptyAddress });
        }
    }

    next() {
        this.setState({ updatingStore: true, updateResult : null, bindQuoteResult: null }, () => {

            const paymentInfo = {
                cardHolderFirstName: this.state.cardHolderFirstName,
                cardHolderLastName: this.state.cardHolderLastName,
                cardExpirationFull: this.state.cardExpirationFull,
                cardNumber: this.state.cardNumber,
                cardExpirationMonth: this.state.cardExpirationMonth,
                cardExpirationYear: this.state.cardExpirationYear,
                billingAddress: this.state.billingAddress,
                savePaymentMethod: this.state.savePaymentMethod
            };

            this.props.updateAppState({ quoteId: this.props.quoteId, paymentInfo: paymentInfo })
                .then((response) => {
                    this.setState({ updateResult: response.data }, () => {
                        if (null !== this.state.updateResult && this.state.updateResult.errors && 0 < this.state.updateResult.errors.length) {
                            this.stopUpdate();
                            return;
                        }
                        this.props.updateAppStateViolations(this.props.quoteId)
                            .then(
                                (violationsResponse) => {
                                    if (violationsResponse.data.hasAdditionalDrivers || this.props.hasAdditionalDrivers) {
                                        this.props.history.push(PATHS.FQ_ADDITIONAL_DRIVERS);
                                    }
                                    else if (violationsResponse.data.hasViolationData) {
                                        this.props.history.push(Utilities.formatUrl(PATHS.FQ_VIOLATIONS, ""));
                                    }
                                    else {
                                        this.props.bindQuote(this.props.quoteId)
                                            .then((bindResponse: IBindQuoteResponse) => {
                                                this.setState({ bindQuoteResult: bindResponse.data.bindQuoteResult }, () => {
                                                    if (null !== this.state.bindQuoteResult && this.state.bindQuoteResult.errors && 0 < this.state.bindQuoteResult.errors.length) {
                                                        this.stopUpdate();
                                                        return;
                                                    }
                                                    if (bindResponse.data.esignatureForms && 0 < bindResponse.data.esignatureForms.length) {
                                                        this.props.history.push(Utilities.formatUrl(PATHS.FQ_GOODTOGO, ""));
                                                    }
                                                    else {
                                                        this.props.history.push(PATHS.FQ_FINISH);
                                                    }
                                                });
                                            },
                                            () => this.stopUpdate());
                                    }
                                },
                                () => this.stopUpdate()
                            );
                    });
                },
                () => this.stopUpdate()
            );
        });
    }

    showErrors(errors: Array<string> | undefined) {
        if (!errors || 0 === errors.length) return null;
        return <Alert variant={"danger"}>
            <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
            <p>Please review errors below</p>
            <ul>
                {
                    errors.map((error) => (
                        <li key={Utilities.uniqueId()}>
                            <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                        </li>
                    ))
                }
            </ul>
        </Alert>;
    }

    render() {
        return (
            <QuoteStep id="payment">
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea">
                        <h5>Payment Info</h5>
                    </div>

                    { this.showErrors(this.state.updateResult?.errors) }
                    { this.showErrors(this.state.bindQuoteResult?.errors) }

                    <p className="info">We will collect the down payment and get you on the road!</p>

                    <div className="policy-details">
                        <div className="payment-choice">
                            <div className="item">
                                <label className="left-cell">${this.props.paymentChoice?.firstPay}</label>
                                <label className="right-cell">Due today</label>
                            </div>
                        </div>
                        <AuthorizeVerify />
                    </div>

                    <div className="break-2" />

                    <ValidatableFormGroup
                        label="Cardholder First Name"
                        value={this.getValueSafe(this.state, "cardHolderFirstName")}
                        placeholder="Cardholder First Name"
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "cardHolderFirstName")}
                        onChange={(e) => { this.setStateValue(e.target.value, "cardHolderFirstName") }} />

                    <ValidatableFormGroup
                        label="Cardholder Last Name"
                        value={this.getValueSafe(this.state, "cardHolderLastName")}
                        placeholder="Cardholder Last Name"
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "cardHolderLastName")}
                        onChange={(e) => { this.setStateValue(e.target.value, "cardHolderLastName") }} />

                    <Rifm
                        accept={/\d/g}
                        format={Utilities.formatInteger}
                        value={this.getValueSafe(this.state, "cardNumber")}
                        onChange={(v) => { this.setStateValue(v, "cardNumber") }}>
                        {({ value, onChange }) => (
                            <ValidatableFormGroup
                                label="Card Number"
                                value={value}
                                placeholder="Card Number"
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "cardNumber")}
                                onChange={(e) => { onChange(e) }}
                                pattern="[0-9]*"
                                inputmode="numeric" />
                        )}
                    </Rifm>

                    <Rifm
                        accept={/\d/g}
                        format={Utilities.formatCreditCardExpiration}
                        value={this.getValueSafe(this.state, "cardExpirationFull")}
                        onChange={(v) => { this.setCardExpirationValues(v) }}>
                        {({ value, onChange }) => (
                            <ValidatableFormGroup
                                label="Card Expiration (Month/Year)"
                                placeholder="MM/YY"
                                value={value}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "cardExpirationFull")}
                                onChange={(e) => { onChange(e) }}
                                pattern="[0-9]*"
                                inputmode="numeric" />
                        )}
                    </Rifm>

                    <div className="break-2" />

                    <div className="titleArea">
                        <h5>Billing Address</h5>
                    </div>

                    <ComplexCheckbox
                        children={
                            <p>Check here if you would like to use the same address info for billing as your home address.</p>
                        }
                        value={this.state.useHomeAddressForBilling}
                        onChange={(e) => this.changeUseHomeAddressAsBilling()} />

                    <Address
                        errors={validationUtils.extractErrorsByPrefix(this.state.errors, "billingAddress.")}
                        value={this.state.billingAddress ? this.state.billingAddress : null}
                        noAddressVerification={true}
                        onChange={this.onBillingAddressChanged} />

                    <ComplexCheckbox
                        children={
                            <p>Automatically use this payment method for future payments. This can be changed at any time.</p>
                        }
                        value={this.state.savePaymentMethod}
                        onChange={(e) => this.setStateValue(true, "savePaymentMethod")} />

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Purchase Policy"
                            disabled={this.state.updatingStore || this.state.invalidBillingAddress}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>

                    <AuthorizeVerify />
                </ValidatableForm>
            </QuoteStep>

        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        quoteId: state.externalQuote?.rtrQuoteId,
        insured: state.externalQuote?.insured,
        paymentChoice: state.paymentChoice,
        hasAdditionalDrivers: _.filter(state.externalQuote?.drivers, (d) => d.fromClue).length > 0,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.PAYMENT)),
        // просто вызвать функцию, которую вернет вызов saveCreditCardPaymentInfo(update.quoteId, update.paymentInfo)
        // а он вернет функцию (dispatch, getState) => ... promise
        updateAppState: (update: IAppStateUpdate) => dispatch(saveCreditCardPaymentInfo(update.quoteId, update.paymentInfo)),
        updateAppStateViolations: (quoteId: number) => dispatch(getViolations(quoteId)),
        bindQuote: (quoteId: number) => dispatch(bindQuote(quoteId))
    };
};

export default connect(mapProps, mapDispatch)(Payment);